import React, { useEffect, useState } from 'react';
import { Save } from 'lucide-react';
import api from '../services/api';
import toast from 'react-hot-toast';

const FIELDS = [
  { section: 'Laundry', fields: [
    { key: 'laundryDefaultAmount', label: 'Default Charge Amount (Rs.)', type: 'number', placeholder: '250' },
  ]},
  { section: 'Bank Details', subtitle: 'Shown on laundry PDF invoices sent to students', fields: [
    { key: 'bankName',          label: 'Bank Name',       type: 'text', placeholder: 'e.g. Bank of Ceylon' },
    { key: 'bankAccountName',   label: 'Account Name',    type: 'text', placeholder: 'e.g. Eden Crest Girls Hostel' },
    { key: 'bankAccountNumber', label: 'Account Number',  type: 'text', placeholder: 'e.g. 1234567890' },
    { key: 'bankBranch',        label: 'Branch',          type: 'text', placeholder: 'e.g. Colombo 03' },
    { key: 'bankBranchCode',    label: 'Branch Code',     type: 'text', placeholder: 'e.g. 001' },
  ]},
];

export default function Settings() {
  const [form, setForm] = useState({
    laundryDefaultAmount: '250',
    bankName: '', bankAccountName: '', bankAccountNumber: '', bankBranch: '', bankBranchCode: '',
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/settings').then(r => setForm(f => ({ ...f, ...r.data }))).catch(console.error);
  }, []);

  const save = async e => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.put('/settings', form);
      toast.success('Settings saved');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Error saving settings');
    } finally { setSaving(false); }
  };

  return (
    <div className="max-w-xl mx-auto">
      <h2 className="text-xl font-bold text-gray-800 mb-6">Settings</h2>
      <form onSubmit={save} className="space-y-6">
        {FIELDS.map(({ section, subtitle, fields }) => (
          <div key={section} className="bg-white rounded-xl shadow-sm border border-gray-100 p-5">
            <h3 className="font-semibold text-gray-800 mb-0.5">{section}</h3>
            {subtitle && <p className="text-xs text-gray-400 mb-4">{subtitle}</p>}
            {!subtitle && <div className="mb-4" />}
            <div className="space-y-3">
              {fields.map(({ key, label, type, placeholder }) => (
                <div key={key}>
                  <label className="text-sm font-medium text-gray-700">{label}</label>
                  <input
                    type={type}
                    value={form[key] || ''}
                    onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))}
                    placeholder={placeholder}
                    className="w-full border rounded-lg px-3 py-2 mt-1 text-sm focus:outline-none focus:ring-2 focus:ring-brand-500"
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
        <button type="submit" disabled={saving}
          className="w-full bg-brand-700 hover:bg-brand-800 disabled:opacity-60 text-white py-2.5 rounded-xl text-sm font-medium flex items-center justify-center gap-2">
          <Save size={16} /> {saving ? 'Saving...' : 'Save Settings'}
        </button>
      </form>
    </div>
  );
}
